module.exports = __webpack_public_path__ + "img/ali.b3959dbe.png";